import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class BancoDoBrasilService {
    constructor(private http: HttpClient) { }

    getDiscount(params: { eventId: string, cpf: string }): Observable<{ hasDiscount: boolean }> {
        return this.http.get<{ hasDiscount: boolean }>(`${environment.apiUrl}/banco-do-brasil/discount/${params.eventId}/${params.cpf}`);
    }
}
